import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '~/libs/api';
import { thunkErrorHandler } from '~/store/utils.ts';

export const generateOtpForMFA = createAsyncThunk(
  'otp/generateOtpForMFA',
  async (phone: string, { rejectWithValue }) => {
    try {
      const headers = {
        'X-Phone': btoa(phone),
      };
      const response = await api.post(`/public/otp/generate?type=VERIFICATION`, undefined, {
        headers,
      });
      return response.data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const generateOtpForRegistration = createAsyncThunk(
  'otp/generateForRegistration',
  async (phone: string, { rejectWithValue }) => {
    try {
      const headers = {
        'X-Phone': btoa(phone),
      };
      const response = await api.post(`/public/otp/generate?type=REGISTRATION`, undefined, {
        headers,
      });
      return response.data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const generateOtpForVerification = createAsyncThunk(
  'otp/generateForVerification',
  async ({ phone, token }: { phone: string; token: string }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        'X-Phone': btoa(phone),
      };

      const response = await api.post(`/otp/generate?type=VERIFICATION`, undefined, {
        headers,
      });
      return response.data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);
